import { render, staticRenderFns } from "./ActivitiesSection.vue?vue&type=template&id=4b0ce9ce&scoped=true&"
import script from "./ActivitiesSection.vue?vue&type=script&lang=js&"
export * from "./ActivitiesSection.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesSection.vue?vue&type=style&index=0&id=4b0ce9ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ce9ce",
  null
  
)

export default component.exports